import { ChekPhoneNumberForm, FormData, formValidation } from './ChekPhoneNumberForm';
export type { FormData };
export { formValidation };
export default ChekPhoneNumberForm;
